import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { resetPassword, sendOtp } from "../../services/api";

const s = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem 1rem",
    background: "#f0f2f5",
  },
  card: {
    background: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: "16px",
    padding: "2.5rem 2rem",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "1.75rem",
  },
  brandName: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1a1a1a",
    letterSpacing: "-0.4px",
  },
  subheading: {
    fontSize: "14px",
    color: "#6b7280",
    marginBottom: "1.75rem",
    textAlign: "center",
  },
  label: {
    display: "block",
    fontSize: "13px",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "6px",
  },
  inputGroup: {
    marginBottom: "1rem",
  },
  input: {
    width: "100%",
    height: "42px",
    padding: "0 12px",
    fontSize: "14px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#d1d5db",
    borderRadius: "8px",
    background: "#f9fafb",
    color: "#1a1a1a",
    outline: "none",
    transition: "border-color 0.15s, box-shadow 0.15s",
    boxSizing: "border-box",
  },

  inputFocused: {
    borderColor: "#534AB7",
    boxShadow: "0 0 0 3px rgba(83,74,183,0.12)",
    background: "#fff",
  },
  passwordWrapper: {
    position: "relative",
  },
  eyeBtn: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    color: "#9ca3af",
    display: "flex",
    alignItems: "center",
  },
  submitBtn: {
    width: "100%",
    height: "44px",
    background: "#534AB7",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "background 0.15s, transform 0.1s",
  },
  submitBtnHover: {
    background: "#3C3489",
    transform: "scale(0.99)",
  },
  submitBtnDisabled: {
    opacity: 0.75,
    cursor: "not-allowed",
  },
  errorBanner: {
    color: "#991b1b",
    fontSize: "13px",
    marginBottom: "14px",
    background: "#fee2e2",
    padding: "8px 12px",
    borderRadius: "6px",
  },
  successBanner: {
    color: "#166534",
    fontSize: "13px",
    marginBottom: "14px",
    background: "#dcfce7",
    padding: "8px 12px",
    borderRadius: "6px",
  },
  backRow: {
    display: "flex",
    justifyContent: "center",
    marginTop: "1rem",
  },
  backBtn: {
    fontSize: "13px",
    color: "#534AB7",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    fontWeight: "500",
  },
  inputError: {
    borderColor: "#E24B4A",
  },
  errorText: {
    fontSize: "12px",
    color: "#ef4444",
    marginTop: "4px",
  },
};

export default function ResetPassword() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    identifier: "",
    otp: "",
    password: "",
    password_confirmation: "",
  });

  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");
  const [focusedField, setFocusedField] = useState(null);
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hoveredBtn, setHoveredBtn] = useState(null);
  const [passwordResetDone, setPasswordResetDone] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [fieldErr, setFieldErr] = useState({
    identifier: "",
    otp: "",
    password: "",
    password_confirmation: "",
  });

  const identifier = form.identifier.trim();
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);
  const isMobile = /^[6-9]\d{9}$/.test(identifier);

  const validateForm = () => {
    const errors = {
      identifier: "",
      otp: "",
      password: "",
      password_confirmation: "",
    };

    const otp = form.otp.trim();
    const password = form.password.trim();
    const confirmPassword = form.password_confirmation.trim();

    if (!identifier) {
      errors.identifier = "Email or Mobile is required";
    } else if (!isEmail && !isMobile) {
      errors.identifier = "Enter valid Email or Mobile number";
    }

    if (!otp) {
      errors.otp = "OTP is required";
    } else if (!/^\d{6}$/.test(otp)) {
      errors.otp = "OTP must be 6 digits";
    }

    if (!password) {
      errors.password = "New Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      errors.password_confirmation = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      errors.password_confirmation = "Password and Confirm Password must match";
    }

    setFieldErr(errors);

    return (
      !errors.identifier &&
      !errors.otp &&
      !errors.password &&
      !errors.password_confirmation
    );
  };

  const handleSendOtp = async () => {
    setErr("");
    setSuccess("");

    if (!identifier) {
      setFieldErr({ ...fieldErr, identifier: "Email or Mobile is required" });
      return;
    }

    if (!isEmail && !isMobile) {
      setFieldErr({
        ...fieldErr,
        identifier: "Enter valid Email or Mobile number",
      });
      return;
    }

    setLoading(true);

    try {
      const result = await sendOtp({ identifier });

      setSuccess(result.data.message || "OTP sent successfully");
      setOtpSent(true);
    } catch (error) {
      setErr(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });
    setFieldErr({ ...fieldErr, [name]: "" });
  };

  const getInputStyle = (field) => ({
    ...s.input,
    ...(focusedField === field ? s.inputFocused : {}),
    ...(fieldErr[field] ? s.inputError : {}),
  });

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setErr("");
    setSuccess("");

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const result = await resetPassword({
        identifier: form.identifier,
        otp: form.otp,
        newPassword: form.password,
      });

      setSuccess(result.data.message || "Password reset successfully");
      setPasswordResetDone(true);
    } catch (error) {
      console.error("Reset password error:", error);
      setErr(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logoRow}>
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Sales Tracker Logo"
          >
            <rect width="36" height="36" rx="10" fill="#534AB7" />
            <path
              d="M10 25V16"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M18 25V11"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M26 25V19"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M9 26H27"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>

          <span style={s.brandName}>Sales Tracker</span>
        </div>

        <div style={s.subheading}>Reset your password</div>

        {err && <div style={s.errorBanner}>{err}</div>}
        {success && <div style={s.successBanner}>{success}</div>}

        {!passwordResetDone && (
          <form onSubmit={handleResetPassword}>
            <div style={s.inputGroup}>
              <label style={s.label}>Email or Mobile</label>
              <input
                style={getInputStyle("identifier")}
                name="identifier"
                value={form.identifier}
                onChange={handleChange}
                placeholder="Enter Email or Mobile"
                onFocus={() => setFocusedField("identifier")}
                onBlur={() => setFocusedField(null)}
                disabled={otpSent}
              />
              {fieldErr.identifier && (
                <div style={s.errorText}>{fieldErr.identifier}</div>
              )}
            </div>
            {!otpSent && (
              <button
                style={{
                  ...s.submitBtn,
                  ...(hoveredBtn === "sendOtp" ? s.submitBtnHover : {}),
                  ...(loading ? s.submitBtnDisabled : {}),
                }}
                onMouseEnter={() => setHoveredBtn("sendOtp")}
                onMouseLeave={() => setHoveredBtn(null)}
                type="button"
                disabled={loading}
                onClick={handleSendOtp}
              >
                {loading ? "Sending..." : "Send OTP"}
              </button>
            )}

            {otpSent && (
              <>
                <div style={s.inputGroup}>
                  <label style={s.label}>OTP</label>
                  <input
                    style={getInputStyle("otp")}
                    name="otp"
                    value={form.otp}
                    onChange={handleChange}
                    placeholder="Enter OTP"
                    onFocus={() => setFocusedField("otp")}
                    onBlur={() => setFocusedField(null)}
                  />
                  {fieldErr.otp && (
                    <div style={s.errorText}>{fieldErr.otp}</div>
                  )}
                </div>
                <div style={s.inputGroup}>
                  <label style={s.label}>New Password</label>
                  <div style={s.passwordWrapper}>
                    <input
                      style={{
                        ...getInputStyle("password"),
                        paddingRight: "40px",
                      }}
                      type={showPwd ? "text" : "password"}
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder="••••••••"
                      onFocus={() => setFocusedField("password")}
                      onBlur={() => setFocusedField(null)}
                    />

                    <button
                      style={s.eyeBtn}
                      onClick={() => setShowPwd((v) => !v)}
                      type="button"
                      title={showPwd ? "Hide password" : "Show password"}
                    >
                      {showPwd ? (
                        <AiOutlineEyeInvisible size={18} color="#9ca3af" />
                      ) : (
                        <AiOutlineEye size={18} color="#9ca3af" />
                      )}
                    </button>
                  </div>
                  {fieldErr.password && (
                    <div style={s.errorText}>{fieldErr.password}</div>
                  )}
                </div>

                <div style={s.inputGroup}>
                  <label style={s.label}>Confirm Password</label>
                  <div style={s.passwordWrapper}>
                    <input
                      style={{
                        ...getInputStyle("password_confirmation"),
                        paddingRight: "40px",
                      }}
                      type={showConfirmPwd ? "text" : "password"}
                      name="password_confirmation"
                      value={form.password_confirmation}
                      onChange={handleChange}
                      placeholder="••••••••"
                      onFocus={() => setFocusedField("password_confirmation")}
                      onBlur={() => setFocusedField(null)}
                    />

                    <button
                      style={s.eyeBtn}
                      onClick={() => setShowConfirmPwd((v) => !v)}
                      type="button"
                      title={showConfirmPwd ? "Hide password" : "Show password"}
                    >
                      {showConfirmPwd ? (
                        <AiOutlineEyeInvisible size={18} color="#9ca3af" />
                      ) : (
                        <AiOutlineEye size={18} color="#9ca3af" />
                      )}
                    </button>
                  </div>
                  {fieldErr.password_confirmation && (
                    <div style={s.errorText}>
                      {fieldErr.password_confirmation}
                    </div>
                  )}
                </div>

                <button
                  style={{
                    ...s.submitBtn,
                    ...(hoveredBtn === "submit" ? s.submitBtnHover : {}),
                    ...(loading ? s.submitBtnDisabled : {}),
                  }}
                  onMouseEnter={() => setHoveredBtn("submit")}
                  onMouseLeave={() => setHoveredBtn(null)}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Resetting..." : "Reset Password"}
                </button>
              </>
            )}
          </form>
        )}

        {passwordResetDone && (
          <div style={s.backRow}>
            <button
              style={s.backBtn}
              type="button"
              onClick={() => navigate("/")}
            >
              Back to Login
            </button>
          </div>
        )}

        {!passwordResetDone && (
          <div style={s.backRow}>
            <button
              style={s.backBtn}
              type="button"
              onClick={() => navigate("/")}
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
